import api from '../library/axios';

export default {
  businessEntities() {
    return api({
      method: 'get',
      url: '/api/business-entity',
    });
  },
  businessTypes() {
    return api({
      method: 'get',
      url: '/api/business-type',
    });
  },
  companyProfile(company_id) {
    return api({
      method: 'get',
      url: `/api/company-profile/${company_id}`,
    });
  },
  updateCompanyProfile({ data }) {
    return api({
      method: 'patch',
      url: '/api/company-profile',
      data,
    });
  },
  myProfile() {
    return api({
      method: 'get',
      url: '/api/profile',
    });
  },
};
